const axios = require("axios");

export const getCustomers = () => {
  return axios.get("/api/customers");
};
